
import { Component, Prop, Vue } from "vue-property-decorator";
import vueI18n from "@/i18n.ts";
import { mapGetters } from "vuex";

@Component({
  name: "LangSelect",
  computed: mapGetters("products", ["getCategories"])
})
export default class LangSelect extends Vue {
  isOpen: boolean = false;
  langArr: string[] = ["de", "us", "uk", "br", "es", "it", "nl", "fr"];
  selectedLang: string = this.langArr[0];
  getCategories: any[];

  @Prop({ default: null })
  addClass: string;

  created() {
    let langFromURL: string = this.$router.currentRoute.fullPath.split("/")[1];
    this.selectedLang = this.$store.getters["app/lang"];
    this.$store.subscribe(this.handleStoreChange);
    if (langFromURL !== this.selectedLang) {
      if (langFromURL.match(/(de|br|us|uk|nl|it|es|fr)/)) {
        this.$store.dispatch("app/setCurrentLang", langFromURL);
      }
    }
  }

  langItemClass(lang) {
    if (lang === this.selectedLang) {
      return "current-lang";
    }
  }

  handleStoreChange(action) {
    if (!action.type.includes("app/setCurrentLang")) {
      return;
    }
    const lang: string = action.payload;
    this.selectedLang = lang;
  }

  setHtmlLang(locale: string) {
    const langs = {
      us: "en",
      uk: "en",
      de: "de",
      br: "pt",
      es: "es",
      fr: "fr",
      nl: "nl"
    };
    document.getElementsByTagName("html")[0].lang = langs[locale];
  }

  async handleLangSelect(lang: string) {
    if (this.selectedLang === lang) {
      return;
    }
    this.setHtmlLang(lang);
    let URLParams: string[] = this.$router.currentRoute.fullPath.split("/");
    let paramsWithoutLang: string = "";
    this.isOpen = false;
    await this.$store.dispatch("app/setCurrentLang", lang.toLocaleLowerCase());
    window.removeEventListener("click", this.handleClickWindow, true);
    let currentRoute = this.$router.currentRoute.fullPath.split("/")[2];

    if (URLParams[1] && URLParams[1].match(/(de|br|us|uk|nl|it|es|fr)/)) {
      URLParams.forEach((param, index) => {
        if (index > 1) {
          paramsWithoutLang += param;
        }
      });
    }
    if (this.$router.currentRoute.name === "article") {
      this.$router.push({ path: `/${lang}/` });
      return;
    }

    if (this.$router.currentRoute.name === "category") {
      this.$router.push({
        path: `/${lang}/${this.$router.currentRoute.fullPath.slice(4)}`
      });
      return;
    }

    if (this.$router.currentRoute.name === "merchant") {
      this.$router.push({
        path: `/${lang}/${this.$router.currentRoute.fullPath.slice(4)}`
      });
      return;
    }

    this.$router.push({ path: `/${lang}/${paramsWithoutLang}` });

    if (this.$router.currentRoute.name === "shops") {
      this.$store.dispatch("shops/getAllShops");
    }

    if (this.$router.currentRoute.name === "products") {
      this.$store.dispatch("products/setLangChangeState", [true]);
      await this.$store.dispatch("products/getCategories");

      const categoryID = this.getCategories[0]["category_id"];
      this.$store.dispatch("products/fetchFilterParams", [categoryID]);
      this.$store.dispatch("products/fetchProducts", {
        category: categoryID,
        count: 20,
        direction: null
      });
      this.$router.push({ path: `/${lang}/products?category=${categoryID}` });

      this.$store.dispatch("products/setLangChangeState", [false]);
    }
  }

  handleClickWindow() {
    this.isOpen = false;
  }

  handleOpen() {
    setTimeout(() => {
      window.addEventListener("click", this.handleClickWindow, true);
    }, 100);
    this.isOpen = true;
  }
}
